var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProducts = function SvgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.999 32.583-12-6.928v-13.77l12 6.928Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18.814 6 11.886l11.925-6.885 12.074 6.884ZM11.962 8.443l12 6.928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.999 25.651-12 6.928v-13.77l12-6.928ZM24.547 25.176l-3.587 2.071M22.551 22.731l-1.591.919"
  }))));
};
export default SvgProducts;